import { render, staticRenderFns } from "./EmployeeRegister.vue?vue&type=template&id=365261ca&"
import script from "./EmployeeRegister.vue?vue&type=script&lang=js&"
export * from "./EmployeeRegister.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeRegister.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports